import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://wordzingo.com';

const PAGE_MESSAGES = {
  '/':                  '🎮 Check out WordZingo — 24 free word games & solvers! No sign-up needed.',
  '/wordle':            '🟩 Play free Wordle on WordZingo — guess the hidden word in 6 tries!',
  '/hangman':           '🎭 Play free Hangman on WordZingo — classic word guessing fun!',
  '/word-search':       '🔎 Play free Word Search puzzles on WordZingo!',
  '/word-scramble':     '⏱️ Race the clock with Word Scramble on WordZingo!',
  '/word-chain':        '⛓️ Play Word Chain on WordZingo — how long can you keep the chain?',
  '/jumble':            '🔀 Solve any jumble puzzle instantly on WordZingo!',
  '/unscramble':        '🔍 Unscramble any word instantly on WordZingo — free!',
  '/anagram-solver':    '🔤 Find every anagram instantly with WordZingo\'s free Anagram Solver!',
  '/anagram-generator': '🎲 Generate creative anagrams on WordZingo!',
  '/crossword':         '✏️ Stuck on a crossword? Solve it instantly on WordZingo!',
  '/wordle-solver':     '💡 Get smart Wordle hints with WordZingo\'s free Wordle Solver!',
  '/boggle':            '🎯 Find every word in your Boggle grid on WordZingo!',
  '/scrabble':          '🃏 Find the highest-scoring Scrabble words on WordZingo!',
  '/word-ladder':       '🪜 Solve Word Ladders step by step on WordZingo!',
  '/rhyme':             '🎵 Find perfect rhymes for any word on WordZingo!',
  '/palindrome':        '🔄 Check if your word is a palindrome on WordZingo!',
  '/sudoku':            '🔢 Solve any Sudoku puzzle instantly on WordZingo!',
  '/spelling-bee':      '🐝 Find all Spelling Bee answers & pangrams on WordZingo!',
  '/longest-word':      '📏 Find the longest possible word from your letters on WordZingo!',
  '/word-pattern':      '🔣 Match any word pattern instantly on WordZingo!',
  '/scrabble-calculator': '🧮 Calculate your Scrabble score on WordZingo!',
  '/pig-latin':         '🐷 Convert English to Pig Latin instantly on WordZingo!',
  '/syllable-counter':  '🔢 Count syllables in any word on WordZingo — great for haiku & poetry!',
  '/word-counter':      '📝 Count words, characters & reading time instantly on WordZingo!',
  '/cryptogram':        '🔐 Decode substitution cipher puzzles with WordZingo\'s free Cryptogram Solver!',
  '/morse-code':        '📡 Convert text to Morse code & play audio on WordZingo — free!',
  '/dordle':            '🟩🟩 Play free Dordle on WordZingo — guess 2 words at once in 7 tries!',
  '/quordle':           '🟩🟩🟩🟩 Play free Quordle on WordZingo — 4 words, 9 guesses, ultimate challenge!',
};

export default function ShareButtons() {
  const [copied, setCopied] = useState(false);
  const location = useLocation();

  const url      = BASE_URL + location.pathname;
  const message  = PAGE_MESSAGES[location.pathname] || '🎮 Check out WordZingo — free word games & solvers!';
  const encUrl   = encodeURIComponent(url);
  const encMsg   = encodeURIComponent(message);

  const BUTTONS = [
    { label: 'X',         icon: 'bi-twitter-x', hoverColor: '#000000',
      href: `https://twitter.com/intent/tweet?text=${encMsg}&url=${encUrl}` },
    { label: 'Facebook',  icon: 'bi-facebook',  hoverColor: '#1877f2',
      href: `https://www.facebook.com/sharer/sharer.php?u=${encUrl}` },
    { label: 'WhatsApp',  icon: 'bi-whatsapp',  hoverColor: '#25d366',
      href: `https://wa.me/?text=${encMsg}%20${encUrl}` },
    { label: 'Reddit',    icon: 'bi-reddit',    hoverColor: '#ff4500',
      href: `https://reddit.com/submit?url=${encUrl}&title=${encMsg}` },
    { label: 'LinkedIn',  icon: 'bi-linkedin',  hoverColor: '#0a66c2',
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encUrl}` },
  ];

  function copyLink() {
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  return (
    <div className="wz-share-bar">
      <div className="container-xl">
        <div className="wz-share-inner">
          <div className="wz-share-label">
            <i className="bi bi-share-fill me-2"></i>Share WordZingo
          </div>
          <div className="wz-share-buttons">
            {BUTTONS.map(b => (
              <a
                key={b.label}
                href={b.href}
                target="_blank"
                rel="noopener noreferrer"
                className="wz-share-btn"
                style={{ '--hover-color': b.hoverColor }}
                title={`Share on ${b.label}`}
              >
                <i className={`bi ${b.icon}`}></i>
                <span>{b.label}</span>
              </a>
            ))}
            <button
              className={`wz-share-btn wz-share-copy ${copied ? 'copied' : ''}`}
              onClick={copyLink}
              title="Copy link"
            >
              <i className={`bi ${copied ? 'bi-check-lg' : 'bi-link-45deg'}`}></i>
              <span>{copied ? 'Copied!' : 'Copy Link'}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
